export default __webpack_public_path__ + "static/media/reinas-hand-food.35cc3cb6.jpeg";